import { useState, useEffect } from "react";

import "../css/PatientSaleHistory.css";

import PatientSaleHistorySale from "./PatientSaleHistorySale";

import ButtonIconH from "../../components/ButtonIconH";
import Dropdown from "../../components/Dropdown";
import DropdownFilter from "../../components/DropdownFilter";

import { post as rpost } from "../js/api";
import { formatCurrency } from "../utils/utils";

import { userData } from "../../js/utils";

const MORE_STEP = 20;

export default ({ patientId, onClickMenuOption, onDataChange }) => {
  const [optics, setOptics] = useState([]);
  const [selectedOptic, setSelectedOptic] = useState(null);
  const [families, setFamilies] = useState([]);
  const [selectedFamilies, setSelectedFamilies] = useState([]);

  const [numSales, setNumSales] = useState(0);
  const [totalSales, setTotalSales] = useState(0);
  const [numReturns, setNumReturns] = useState(0);
  const [totalReturns, setTotalReturns] = useState(0);
  const [totalPending, setTotalPending] = useState(0);

  const [sales, setSales] = useState([]);

  const [start, setStart] = useState(0);

  const loadSales = async (saleFrom, opticId, familyIds, start, total) => {
    const response = await rpost("ventas/ListarHistoricoCompras.php", {
      token: userData.token,
      idPaciente: patientId,
      optica: opticId,
      familias: familyIds,
      start,
      total,
    });

    const salesN = structuredClone(saleFrom);

    response.forEach((sale) => {
      const lines = sale.lineas.map((line) => {
        return {
          code: line.codigo,
          description: line.descripcion,
          pvp: line.pvp,
          porcDto: line.porcDto,
          porcIVA: line.porcIVA,
          pvu: line.pvu,
          uds: line.uds,
          total: line.totalLinea,
        };
      });

      const s = {
        id: sale.idVenta,
        date: sale.fecha,
        opticName: sale.nombreOptica,
        soldBy: sale.realizadoPor,
        campaign: sale.motivo,
        type: sale.tipo,
        total: sale.total,
        paid: sale.totalAbonado,
        // Si la compra está marcada como pagada no queda nada pendiente,
        // sea cual sea la diferencia entre total y abono.
        pending: sale.pagado == 1 ? 0 : sale.total - sale.totalAbonado,
        lines,
      };

      salesN.push(s);
    });

    setSales(salesN);
  };

  const loadSummaries = async () => {
    const response = await rpost("ventas/ListarHistoricoComprasResumen.php", {
      token: userData.token,
      idPaciente: patientId,
    });
    setNumSales(response.numVentas);
    setTotalSales(response.totalVentas);
    setNumReturns(response.numDevoluciones);
    setTotalReturns(response.totalDevoluciones);
    setTotalPending(response.totalPendiente);

    const opticsN = response.opticas.map((optic) => {
      return {
        id: optic.id,
        text: optic.nombre,
      };
    });
    opticsN.unshift({
      id: -1,
      text: "TODAS",
    });
    setOptics(opticsN);
    setSelectedOptic(opticsN[0]);

    const familiesN = response.familias.map((family) => {
      return {
        id: family.codigo,
        text: family.descripcion,
        active: false,
      };
    });
    setFamilies(familiesN);
    setSelectedFamilies([]);

    setStart(1);

    loadSales(sales, -1, -1, 0, 1);
  };

  const viewMore = () => {
    loadSales(sales, selectedOptic.id, selectedFamilies, start, MORE_STEP);
    setStart(start + MORE_STEP);
  };

  const onChangeOptic = (e) => {
    if (e.id !== selectedOptic.id) {
      setSelectedOptic(e);
      loadSales([], e.id, selectedFamilies, 0, MORE_STEP);
      setStart(MORE_STEP);
    }
  };

  const onChangeFamily = (e) => {
    let familiesN = structuredClone(families);
    const p = familiesN.findIndex((family) => family.id === e.id);
    let selectedFamiliesN = structuredClone(selectedFamilies);
    const pos = selectedFamilies.findIndex((family) => family === e.id);
    if (pos >= 0) {
      familiesN[p].active = false;
      selectedFamiliesN = selectedFamilies.filter((family) => family !== e.id);
    } else {
      familiesN[p].active = true;
      selectedFamiliesN.push(e.id);
    }
    setFamilies(familiesN);
    setSelectedFamilies(selectedFamiliesN);

    loadSales([], selectedOptic.id, selectedFamiliesN, 0, MORE_STEP);
    setStart(MORE_STEP);
  };

  useEffect(() => {
    if (onDataChange) {
      onDataChange({
        sales,
        numSales,
        totalSales,
        numReturns,
        totalReturns,
        totalPending,
      });
    }
  }, [sales, numSales, totalSales, numReturns, totalReturns, totalPending]);

  useEffect(() => {
    if (patientId && patientId === -1) {
      // Nuevo paciente
      setSales([]);
    }
    if (patientId && patientId !== -1) {
      // Carga de paciente
      loadSummaries();
    }
  }, [patientId]);

  return (
    <>
      {sales.length > 0 && (
        <div className="section-patient-sale-history">
          <div className="section-patient-sale-history-summary">
            <div className="section-patient-sale-history-summary-info">
              <span>
                {" "}
                Ventas ({numSales}): {formatCurrency(totalSales)}
              </span>
              <span>
                {" "}
                Devoluciones ({numReturns}): {formatCurrency(totalReturns)}
              </span>
              <span>
                Pendiente: <span>{formatCurrency(totalPending)}</span>
              </span>
            </div>
            <div className="section-patient-sale-history-summary-filters">
              <div>
                <span className="section-patient-sale-history-summary-filters-label">
                  Óptica
                </span>
                <Dropdown
                  id="section-patient-sale-history-optic"
                  tabIndex={100}
                  optionList={optics}
                  size={2}
                  op={selectedOptic?.id}
                  onChange={onChangeOptic}
                  mandatory={true}
                />
              </div>
              <div>
                <DropdownFilter
                  id="section-patient-sale-history-family"
                  tabIndex={101}
                  optionList={families}
                  size={2}
                  op="FAMILIAS"
                  selectedOptions={selectedFamilies}
                  onChange={onChangeFamily}
                />
              </div>
            </div>
          </div>
          {start === 1 && (
            <span className="section-history-header">Última compra</span>
          )}
          {start === 1 && <div className="section-content-sep" />}
          {sales.map((sale, index) => {
            return (
              <PatientSaleHistorySale
                key={index}
                id={sale.id}
                date={sale.date}
                opticName={sale.opticName}
                soldBy={sale.soldBy}
                campaign={sale.campaign}
                type={sale.type}
                total={sale.total}
                paid={sale.paid}
                pending={sale.pending}
                lines={sale.lines}
                onClickMenuOption={onClickMenuOption}
              />
            );
          })}
          <div className="section-footer-button">
            <ButtonIconH
              text={"Ver más (+" + MORE_STEP + ")"}
              small={true}
              onClick={viewMore}
            />
          </div>
        </div>
      )}
      {sales.length === 0 && <div>SIN DATOS</div>}
    </>
  );
};
